import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';
import {addSuccessMessage} from '../SnackBar';

export const APPLICATION_PATCH_REQUEST = 'PATCH_APPLICATION_REQUEST';
export const APPLICATION_PATCH_FAILURE = 'PATCH_APPLICATION_FAILURE';
export const APPLICATION_PATCH_SUCCESS = 'PATCH__APPLICATION_SUCCESS';

export const patchApplication = (data, id) => {
    return function(dispatch) {
        const params = [];
        params['id'] = id;
        dispatch(patchRequest());
        return axios(apiRequestOptions(apiPath.APPLICATIONS.PATCH, data, {params}))
            .then(transformHttpResponse)
            .then(response => {
                dispatch(patchSuccess(response.data));
                dispatch(addSuccessMessage('Application successfully changed'));
            })
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch(postFailure(error));
                dispatch(errorRequestHandler(error));
            });
    }
};

const patchRequest = () => ({type: APPLICATION_PATCH_REQUEST});
const postFailure = error => ({type: APPLICATION_PATCH_FAILURE, error});
const patchSuccess = application => ({type: APPLICATION_PATCH_SUCCESS, application});
